"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
var verticalPlacement = {
    '&$center': {
        left: '50%',
        transform: 'translateX(-50%)',
    },
    '&$end': {
        right: 0,
    },
    '&$start': {
        left: 0,
    },
};
var horizontalPlacement = {
    '&$center': {
        top: '50%',
        transform: 'translateY(-50%)',
    },
    '&$end': {
        bottom: 0,
    },
    '&$start': {
        top: 0,
    },
};
exports.default = react_jss_1.createUseStyles({
    withArrow: {},
    center: {},
    start: {},
    end: {},
    wrapper: {
        position: 'relative',
        display: 'inline-block',
    },
    tooltipInner: function (_a) {
        var theme = _a.theme, color = _a.color;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 3 : 9 }), lineHeight: theme.lineHeight, fontSize: theme.fontSizes.sm, borderRadius: theme.radius.sm, padding: [theme.spacing.xs / 2, theme.spacing.xs], color: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.white, position: 'relative', '&$withArrow::before': {
                display: 'block',
                position: 'absolute',
                content: '""',
                width: 0,
                height: 0,
                borderStyle: 'solid',
            } }));
    },
    tooltip: {
        display: 'inline-block',
        position: 'absolute',
    },
    top: function (_a) {
        var gutter = _a.gutter, theme = _a.theme, color = _a.color, arrowSize = _a.arrowSize;
        return (__assign(__assign({}, verticalPlacement), { bottom: "calc(100% + " + gutter + "px)", '& $tooltipInner$withArrow::before': {
                top: '100%',
                borderWidth: arrowSize + "px " + arrowSize + "px 0 " + arrowSize + "px",
                borderColor: theme_1.getThemeColor({
                    theme: theme,
                    color: color,
                    shade: theme.colorScheme === 'dark' ? 3 : 9,
                }) + " transparent transparent transparent",
            }, '&$center $tooltipInner$withArrow::before': {
                left: "calc(50% - " + arrowSize + "px)",
            }, '&$start $tooltipInner$withArrow::before': {
                left: arrowSize,
            }, '&$end $tooltipInner$withArrow::before': {
                right: arrowSize,
            } }));
    },
    bottom: function (_a) {
        var gutter = _a.gutter, theme = _a.theme, color = _a.color, arrowSize = _a.arrowSize;
        return (__assign(__assign({}, verticalPlacement), { top: "calc(100% + " + gutter + "px)", '& $tooltipInner$withArrow::before': {
                bottom: '100%',
                borderWidth: "0 " + arrowSize + "px " + arrowSize + "px " + arrowSize + "px",
                borderColor: "transparent transparent " + theme_1.getThemeColor({
                    theme: theme,
                    color: color,
                    shade: theme.colorScheme === 'dark' ? 3 : 9,
                }) + " transparent",
            }, '&$center $tooltipInner$withArrow::before': {
                left: "calc(50% - " + arrowSize + "px)",
            }, '&$start $tooltipInner$withArrow::before': {
                left: arrowSize,
            }, '&$end $tooltipInner$withArrow::before': {
                right: arrowSize,
            } }));
    },
    right: function (_a) {
        var gutter = _a.gutter, theme = _a.theme, color = _a.color, arrowSize = _a.arrowSize;
        return (__assign(__assign({}, horizontalPlacement), { left: "calc(100% + " + gutter + "px)", '& $tooltipInner$withArrow::before': {
                right: '100%',
                borderWidth: arrowSize + "px " + arrowSize + "px " + arrowSize + "px 0",
                borderColor: "transparent " + theme_1.getThemeColor({
                    theme: theme,
                    color: color,
                    shade: theme.colorScheme === 'dark' ? 3 : 9,
                }) + " transparent transparent",
            }, '&$center $tooltipInner$withArrow::before': {
                top: "calc(50% - " + arrowSize + "px)",
            }, '&$start $tooltipInner$withArrow::before': {
                top: arrowSize,
            }, '&$end $tooltipInner$withArrow::before': {
                bottom: arrowSize,
            } }));
    },
    left: function (_a) {
        var gutter = _a.gutter, theme = _a.theme, color = _a.color, arrowSize = _a.arrowSize;
        return (__assign(__assign({}, horizontalPlacement), { right: "calc(100% + " + gutter + "px)", '& $tooltipInner$withArrow::before': {
                left: '100%',
                borderWidth: arrowSize + "px 0 " + arrowSize + "px " + arrowSize + "px",
                borderColor: "transparent transparent transparent " + theme_1.getThemeColor({
                    theme: theme,
                    color: color,
                    shade: theme.colorScheme === 'dark' ? 3 : 9,
                }),
            }, '&$center $tooltipInner$withArrow::before': {
                top: "calc(50% - " + arrowSize + "px)",
            }, '&$start $tooltipInner$withArrow::before': {
                top: arrowSize,
            }, '&$end $tooltipInner$withArrow::before': {
                bottom: arrowSize,
            } }));
    },
}, { link: true });
